<template>
    <div v-if="value.length > 0">
        <TooltipComp
            class="w-100 d-flex"
            trigger="click"
            :text="computedValues"
            ><span v-html="formatValue(value[0])"></span
        ></TooltipComp>
    </div>
</template>

<script setup lang="ts">
import { TooltipComp } from '@/components';
import { DeviceMessage, StationDeviceStatus } from '@/objects/generated';
import { formatDateDefault } from '@/utilities/dateutils';
import { computed, toRaw } from 'vue';

const props = defineProps<{
    value: Array<DeviceMessage>;
    row: StationDeviceStatus;
}>();

const formatValue = (v: DeviceMessage | null) => {
    if (v == null) return '';
    return `${formatDateDefault(v.Time, 'TIME')} <b>${v.TypeText}</b> ${v.Value!}`;
};

const computedValues = computed(() => {
    let newlist = toRaw(props.value);

    // Sort Date objects descending by .Time
    newlist.sort((a, b) => {
        return b.Time.getTime() - a.Time.getTime();
    });

    return newlist.map((v) => formatValue(v)).join('<br>');
});
</script>
